var map = {
	"./kv-logo-m-chs.png": 7621,
	"./kv-logo-m-cht.png": 34836,
	"./kv-logo-m-en.png": 45310,
	"./kv-logo-m-jp.png": 24553,
	"./kv-logo-m-kr.png": 44245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72213;